import React, { useState } from "react";
import { ModalDefault } from "../containers/ModalDefault";
import { ButtonDefault } from "../controls/Button/ButtonDefault";
import { BsX } from "react-icons/bs";
import {
    color_black,
    color_grey_dark,
    color_grey_light,
    color_grey_ultra_light,
    color_red_default
} from "../../constants/colors";
import { OnestNormalSmall } from "../styled/TextComponents";
import { useI18n } from "../../i18n/I18nProvider";

const CARD_WIDTH = 305;

const ModalPrompt = ({
    modalOpen,
    setModalOpen,
    changeData,
    setChangeData,
    onSave,
}) => {
    const { t } = useI18n();

    const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true);

    const handleSave = () => {
        onSave();
        setModalOpen(false);
        setIsSaveButtonDisabled(true);
    };

    return (
        <ModalDefault
            onRequestClose={() => setModalOpen(false)}
            isOpen={modalOpen}
            modalWidth={CARD_WIDTH}
            centerOnMobile
        >
            <div
                style={{
                    width: CARD_WIDTH,
                    boxSizing: "border-box",
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: "white",
                    borderRadius: 20,
                    padding: 20,
                    gap: 10,
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                        gap: 8,
                    }}
                >
                    <OnestNormalSmall style={{ flex: 1, minWidth: 0, margin: 0 }}>
                        {changeData.changeText ? changeData.changeText : ""}
                    </OnestNormalSmall>
                    <button
                        type="button"
                        aria-label={t("Закрыть")}
                        onClick={() => setModalOpen(false)}
                        style={{
                            flexShrink: 0,
                            width: 32,
                            height: 32,
                            margin: 0,
                            padding: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "none",
                            borderRadius: 8,
                            background: "transparent",
                            cursor: "pointer",
                            color: color_grey_dark,
                        }}
                    >
                        <BsX style={{ fontSize: 28 }} />
                    </button>
                </div>
                <input
                    style={{
                        width: "100%",
                        boxSizing: "border-box",
                        height: 50,
                        borderRadius: 10,
                        paddingLeft: 15,
                        paddingRight: 15,
                        color: color_black,
                        backgroundColor: color_grey_ultra_light,
                        border: "0px solid grey",
                    }}
                    type="number"
                    min={0}
                    step={5}
                    value={changeData.changeValue || 0}
                    onChange={(e) => {
                        setIsSaveButtonDisabled(false);
                        setChangeData({
                            ...changeData,
                            changeValue: e.target.value === "" ? 0 : e.target.value,
                        });
                    }}
                />
                <div onClick={handleSave}>
                    <ButtonDefault
                        width={CARD_WIDTH - 40}
                        height={40}
                        backgroundColor={isSaveButtonDisabled ? color_grey_light : color_red_default}
                        disabled={isSaveButtonDisabled}
                    >
                        {t("Сохранить")}
                    </ButtonDefault>
                </div>
            </div>
        </ModalDefault>
    );
};

export default ModalPrompt;
